import { render } from "./ModalCategoryRemove.vue?vue&type=template&id=22141d87"
import script from "./ModalCategoryRemove.vue?vue&type=script&lang=js"
export * from "./ModalCategoryRemove.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__